export const REFUND_BATCH_GETTING = 'config/refund_getting';
export const gettingRefundBatchConfig= () => ({
  type: REFUND_BATCH_GETTING
});

export const REFUND_BATCH_GET_SUCCESS = 'config/refund_get_success';
export const getRefundBatchConfigOnSuccess= data => ({
  type: REFUND_BATCH_GET_SUCCESS,
  payload: data
});

export const REFUND_BATCH_GET_FAILED = 'config/refund_get_failed';
export const getRefundBatchConfigOnFailed = error => ({
  type: REFUND_BATCH_GET_FAILED,
  payload: error
});

export const REFUND_BATCH_UPDATING = 'config/refund_updating';
export const updatingRefundBatchConfig = data => ({
  type: REFUND_BATCH_UPDATING,
  payload: data
});

export const REFUND_BATCH_UPDATE_SUCCESS = 'config/refund_update_success';
export const updateRefundBatchConfigOnSuccess = data => ({
  type: REFUND_BATCH_UPDATE_SUCCESS,
  payload: data
});

export const REFUND_BATCH_UPDATED_FAILED = 'config/refund_update_failed';
export const updateRefundBatchConfigOnFailed = error => ({
  type: REFUND_BATCH_UPDATED_FAILED,
  payload: error
});